import type { Nullable } from '../../../types';
import type { IubendaService } from '../iubendaService';
import type { IubendaRepository } from '../../../network/repositories/iubendaRepository';
import type { ISubject, ILegalNotice } from '../../../entities';

export default class IubendaServiceImpl implements IubendaService {
  iubendaRepository: IubendaRepository;

  constructor(iubendaRepository: IubendaRepository) {
    this.iubendaRepository = iubendaRepository;
  }

  createConsent(
    subject: ISubject,
    preferences: {
      general: boolean;
    },
    legalNotices: Nullable<Array<ILegalNotice>>
  ): Promise<boolean> {
    const { iubendaRepository } = this;
    return iubendaRepository.createConsent(subject, preferences, legalNotices);
  }
}
